import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import User from 'src/store/models/User';
import Group from 'src/store/models/Group';
import Client from 'src/store/models/Client';
import Phase from 'src/store/models/Phase';
import PhaseCategory from 'src/store/models/PhaseCategory';
import ExpenseCategory from 'src/store/models/ExpenseCategory';
import Project from 'src/store/models/Project';
import ProjectUser from 'src/store/models/ProjectUser';
import TagList from 'src/store/models/TagList';
import Tag from 'src/store/models/Tag';
import Country from 'src/store/models/Country';
import Zone from 'src/store/models/Zone';
import moment from 'moment';
import { capitalize, snakeCase, includes, isEqual, isNil, forEach, merge } from 'lodash';
import TodoList from 'src/store/models/TodoList';
import Todo from 'src/store/models/Todo';
import { pickerUtils } from 'src/mixins/picker-utils';
export default {
  name: 'EntityPicker',
  mixins: [pickerUtils],
  props: {
    controlIdentifier: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disablePicker: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    type: {
      required: true,
      type: String
    },
    captions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    additionalOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disable: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    exclude: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    include: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    only: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parentId: {
      default: null
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    requireServer: {
      type: Boolean,
      default: false
    },
    // when require server is true, persist fetched values in store
    persistOnStore: {
      type: Boolean,
      default: false
    },
    onLoadingComplete: {
      default: null
    },
    customOption: {
      default: null
    },
    ignoreLastUsed: {
      default: false,
      type: Boolean
    },
    external: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    externalOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    customLabel: {
      type: Boolean,
      default: false
    },
    selectIfSingleOption: {
      // If true, will select the option if only one option is available
      type: Boolean,
      default: false
    },
    //
    // those are props that are needed for q-select
    //
    value: {
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    label: {},
    multiple: {
      type: Boolean,
      default: false
    },
    fillInput: {},
    hideSelected: {},
    color: null,
    bgColor: null,
    labelColor: {},
    dark: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    standout: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    noErrorIcon: {
      type: Boolean,
      default: false
    },
    hideBottomSpace: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String
    },
    rules: {
      default: function _default() {
        return [];
      }
    },
    lazyRules: {
      type: Boolean,
      default: false
    },
    mapOptions: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: null
    },
    errorMessage: String
  },
  data: function data() {
    return {
      typeString: this.type === 'todo' ? 'task' : this.type === 'todo_list' ? 'task_list' : this.type.replace(' ', '_').replace('-', '_'),
      originalValue: this.value,
      originOptions: [],
      options: [],
      loading: false,
      loadedFromServer: false,
      filtersChanged: false,
      changeLastUsed: false,
      filteredVal: ''
    };
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler(value, oldValue) {
        this.changeFilters(value, oldValue);
      }
    },
    parentId: 'parentChange',
    value: 'forceValue'
  },
  computed: {
    selectedVal: {
      get: function get() {
        return this.value || (this.multiple ? [] : null);
      },
      set: function set(val) {
        this.updateValue(val);
      }
    },
    pickerType: function pickerType() {
      return capitalize(this.type) + this.$t('components.pickers.picker');
    },
    showCaption: function showCaption() {
      return this.captions.length > 0;
    },
    showAdditionalOptions: function showAdditionalOptions() {
      return this.additionalOptions.length > 0;
    },
    isValueSelected: function isValueSelected() {
      return this.multiple ? this.selectedVal.length : this.selectedVal;
    },
    canCreateEntity: function canCreateEntity() {
      var _this = this;

      if (this.type === 'project') {
        return this.me.is_admin || this.me.is_gm;
      }

      if (this.type === 'client') {
        return this.me.is_admin;
      }

      if (this.type === 'phase' && this.parentName === 'project') {
        var project = Project.query().with('users').find(this.parentId);
        var userInProject = project && project.users.find(function (user) {
          return parseInt(user.user_id) === parseInt(_this.me.user_id);
        });
        return userInProject && userInProject.pivot.is_pm || this.me.is_admin;
      }

      return true;
    },
    newRowName: function newRowName() {
      var name = this.$t('components.pickers.create_new_option');

      switch (this.type) {
        case 'user':
          name = this.$t('components.pickers.invite_member');
          break;

        case 'tag-list':
          name = this.$t('components.pickers.create_new_tag_list');
          break;

        case 'todo-list':
          name = this.$t('components.pickers.create_new_task_list');
          break;

        case 'expense-category':
          name = this.$t('general.create_new_expense_category');
          break;

        default:
          name = this.$t('components.pickers.create_new_element', {
            el: this.$tc("general.".concat(this.type === 'todo' ? 'task' : this.type === 'todo-list' ? 'task_list' : this.type.replace('-', '_')), 1).toLowerCase()
          });
      }

      return name;
    },
    entityModel: function entityModel() {
      var model;

      switch (this.type) {
        case 'user':
          model = User;
          break;

        case 'group':
          model = Group;
          break;

        case 'project':
          model = Project;
          break;

        case 'client':
          model = Client;
          break;

        case 'phase':
          model = Phase;
          break;

        case 'category':
          model = PhaseCategory;
          break;

        case 'expense-category':
          model = ExpenseCategory;
          break;

        case 'tag-list':
          model = TagList;
          break;

        case 'tag':
          model = Tag;
          break;

        case 'todo':
          model = Todo;
          break;

        case 'todo-list':
          model = TodoList;
          break;

        case 'country':
          model = Country;
          break;

        case 'zone':
          model = Zone;
          break;
      }

      return model;
    },
    entityFavoritedParam: function entityFavoritedParam() {
      switch (this.type) {
        case 'project':
          return 'is_favorited';

        case 'report':
          return 'is_favorite';

        default:
          return '';
      }
    },
    entityActiveParam: function entityActiveParam() {
      var param = '';

      switch (this.type) {
        case 'project':
          param = 'is_active';
          break;

        case 'client':
          param = 'is_active';
          break;

        case 'tag_list':
          param = 'is_active';
          break;

        case 'tag':
          param = 'is_active';
          break;

        case 'phase':
          param = 'is_open';
          break;

        case 'phase-category':
          param = 'enabled';
          break;

        case 'user':
          param = 'enabled';
          break;
      }

      return param;
    },
    entityId: function entityId() {
      var id = snakeCase(this.type) + '_id';

      switch (this.type) {
        case 'phase':
          id = 'task_id';
          break;

        case 'category':
          id = 'task_category_id';
          break;

        case 'country':
          id = 'country_code';
          break;

        case 'expense-category':
          id = 'expense_category_id';
          break;

        case 'todo-list':
          id = 'todo_list_id';
          break;

        case 'external':
          id = 'value';
      }

      return id;
    },
    placeholderNameSelected: function placeholderNameSelected() {
      return this.$tc('general.number_' + this.type.replace('-', '_') + '_selected', this.selectedVal.length, {
        number: this.selectedVal.length
      });
    },
    entityName: function entityName() {
      var name = '';

      switch (this.type) {
        case 'user':
          name = this.$tc('roles.description.member', 2).toLowerCase();
          break;

        case 'category':
          name = this.$tc('general.category', 2).toLowerCase();
          break;

        case 'expense-category':
          name = this.$tc('general.expense_category', 2).toLowerCase();
          break;

        case 'tag-list':
          name = this.$tc('general.tag_list', 2).toLowerCase();
          break;

        case 'todo':
          name = this.$tc('general.task', 2).toLowerCase();
          break;

        case 'todo-list':
          name = this.$tc('general.task_list', 2).toLowerCase();
          break;

        case 'country':
          name = this.$tc('general.country', 2).toLowerCase();
          break;

        case 'external':
          name = this.$tc('components.pickers.option', 2).toLowerCase();
      }

      return name;
    },
    entityURI: function entityURI() {
      var entity = this.type + 's';

      switch (this.type) {
        case 'category':
          entity = 'phase-categories';
          break;

        case 'expense-category':
          entity = 'expense-categories';
          break;

        case 'country':
          entity = 'countries';
          break;
      }

      return '/' + entity;
    },
    parentName: function parentName() {
      var name = this.type;

      switch (this.type) {
        case 'project':
          name = 'client';
          break;

        case 'phase':
        case 'todo-list':
          name = 'project';
          break;

        case 'tag':
          name = 'tag_list';
          break;
      }

      return name;
    }
  },
  methods: {
    // functions that change the selected value
    forceValue: function forceValue(newValue) {
      if (newValue !== this.selectedVal) {
        this.selectedVal = newValue || (this.multiple ? [] : null);
      }
    },
    updateValue: function updateValue(value) {
      // Control changed because the value incoming can be a string and also a array
      if (value === 'new-value' || Array.isArray(value) && value.includes('new-value')) {
        this.hidePopup();
        this.createNewEntity();
      } else {
        var changed = this.selectedVal !== value;

        if (changed) {
          if (this.multiple && !Array.isArray(value)) {
            this.$emit('input', [value]);
          } else {
            this.$emit('input', value);
          }

          this.$emit('change');
        }
      }
    },
    clearValue: function clearValue() {
      this.selectedVal = this.multiple ? [] : null;
      this.$refs.select.blur();
    },
    focus: function focus() {
      this.$emit('focus');
    },
    resetValue: function resetValue() {
      this.selectedVal = this.multiple ? [] : includes(this.additionalOptions, 'no-entity') || includes(this.additionalOptions, 'no-selection') || includes(this.additionalOptions, 'all-option') ? -1 : null;
    },
    parentChange: function parentChange(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.changeLastUsed = true;
        this.loadedFromServer = false;
        this.originOptions = [];
        this.resetValue();
        this.filterData('', function (callback) {
          return callback();
        }, function () {});
      }
    },
    changeFilters: function changeFilters(newFilters, oldFilters) {
      if (!isEqual(newFilters, oldFilters)) {
        this.filtersChanged = true;
        this.loadedFromServer = false;
        this.originOptions = []; // this.resetValue()

        this.filterData('', function (callback) {
          return callback();
        }, function () {});
      }
    },
    // utility functions
    selectAll: function selectAll() {
      var _this2 = this;

      var options = this.originOptions.filter(function (entity) {
        return !entity.disable;
      }).map(function (entity) {
        return entity[_this2.entityId];
      });

      if (includes(this.additionalOptions, 'no-entity')) {
        options.push(-1);
      }

      this.updateValue(options);
    },
    getSelectableOptions: function getSelectableOptions(options) {
      return options.filter(function (option) {
        return !option.disable && !option.additionalRow && !option.separator;
      });
    },
    clearLoadingState: function clearLoadingState() {
      var _this3 = this;

      if (this.$refs.select) {
        this.$nextTick(function () {
          _this3.$refs.select.refresh();
        });
      }

      if (this.loading) {
        this.$emit('loaded');
        this.loading = false;
        this.startFilter(false);

        if (this.onLoadingComplete) {
          this.onLoadingComplete(this);
        }
      }
    },
    hidePopup: function hidePopup() {
      this.$refs.select.hidePopup();
    },
    getParams: function getParams() {
      var params = {
        sort_by: 'name',
        per_page: 100,
        abridged: 1
      };

      if (this.filters) {
        merge(params, this.filters);
      }

      if (this.parentId && this.parentId > 0) {
        switch (this.type) {
          case 'project':
            params.client_id = this.parentId;
            break;

          case 'phase':
          case 'todo-list':
            params.project_id = this.parentId;
            break;

          case 'tag':
            params.tag_list_id = this.parentId;
            break;
        }
      }

      return params;
    },
    createNewEntity: function createNewEntity() {
      var _this4 = this;

      var options = {
        name: this.filteredVal,
        onComplete: function onComplete(entity) {
          _this4.originOptions = [];
          _this4.loadedFromServer = false;

          _this4.filterData('', function (callback) {
            return callback();
          }, function () {});

          _this4.updateValue(entity[_this4.entityId]);
        }
      };

      switch (this.type) {
        case 'project':
          options.name = this.$refs.pickerInput.value;

          if (this.parentId && this.parentId > 0) {
            options.client_id = this.parentId;
          }

          this.openDialog('ProjectDialog', options);
          break;

        case 'group':
          options.name = this.$refs.pickerInput.value;

          if (this.parentId && this.parentId > 0) {
            options.client_id = this.parentId;
          }

          this.openDialog('GroupDialog', options);
          break;

        case 'client':
          options.name = this.$refs.pickerInput.value;
          this.openDialog('ClientDialog', options);
          break;

        case 'phase':
          if (this.parentId) {
            options.project_id = this.parentId;
          }

          this.openDialog('CreatePhaseDialog', options);
          break;

        case 'user':
          this.openDialog('InviteUsersDialog', options);
          break;

        case 'todo-list':
          if (this.parentId) {
            options.project_id = this.parentId;
          } // todo ?
          // this.openDialog('CreateTodoListDialog', options)


          break;

        case 'expense-category':
          this.openDialog('ExpenseCategoryDialog', options);
          break;
      }
    },
    sortEntities: function sortEntities(entities) {
      var _this5 = this;

      return entities.sort(function (a, b) {
        var _a$name;

        if (_this5.entityFavoritedParam && a[_this5.entityFavoritedParam] !== undefined && b[_this5.entityFavoritedParam] !== undefined) {
          if (a[_this5.entityFavoritedParam] !== b[_this5.entityFavoritedParam]) {
            return b[_this5.entityFavoritedParam] - a[_this5.entityFavoritedParam];
          }
        }

        if (_this5.entityActiveParam && a[_this5.entityActiveParam] !== undefined && b[_this5.entityActiveParam] !== undefined) {
          if (a[_this5.entityActiveParam] !== b[_this5.entityActiveParam]) {
            return b[_this5.entityActiveParam] - a[_this5.entityActiveParam];
          }
        }

        return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : _a$name.localeCompare(b === null || b === void 0 ? void 0 : b.name);
      });
    },
    changeInput: function changeInput() {
      this.loadedFromServer = false;
      this.startFilter();
    },
    startFilter: function startFilter() {
      var _this6 = this;

      var focusInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.loading) {
        this.filterData(this.filteredVal, function (callback) {
          return callback();
        }, function () {});

        if (focusInput) {
          setTimeout(function () {
            if (_this6.$refs.pickerInput) {
              _this6.$refs.pickerInput.focus();
            }
          }, 10);
        }
      }
    },
    updateFromLastUsed: function updateFromLastUsed() {
      var _this7 = this;

      // TODO revisit this code
      var selectableOptions = this.getSelectableOptions(this.options);

      if (selectableOptions.length === 1) {
        this.selectedVal = selectableOptions[0][this.entityId];
        return;
      }

      if (this.type === 'project') {
        var lastUsedData = Project.getLastUsedData({
          userId: this.filters.user_id > 0 ? this.filters.user_id : this.me.user_id,
          clientId: this.parentId && this.parentId > 0 ? this.parentId : null
        });
        this.selectedVal = lastUsedData.projectId;
      } else if (this.type === 'phase' && this.parentId) {
        var _lastUsedData = Project.getLastUsedData({
          userId: this.filters.user_id > 0 ? this.filters.user_id : this.me.user_id,
          projectId: this.parentId
        });

        if (this.originOptions.filter(function (entity) {
          return entity[_this7.entityId] === _lastUsedData.phaseId;
        }).length > 0) {
          this.selectedVal = _lastUsedData.phaseId;
        }
      }
    },
    resetFilterVal: function resetFilterVal() {
      this.filteredVal = '';
    },
    // functions that change our originData
    getFromModel: function getFromModel() {
      var _this8 = this;

      var params = this.getParams();
      var modelEntities = this.entityModel.query().where(function (entity) {
        if (_this8.parentId && _this8.parentId > 0) {
          return entity[_this8.parentName + '_id'] === _this8.parentId;
        }

        return true;
      });

      if (this.type === 'user') {
        var _params$project_ids;

        modelEntities = modelEntities.with('avatar');

        if (((_params$project_ids = params.project_ids) === null || _params$project_ids === void 0 ? void 0 : _params$project_ids.length) > 0) {
          modelEntities = modelEntities.whereHas('projects', function (projects) {
            projects.whereIdIn(params.project_ids).orWhere('is_public', true);
          });
        }

        if (params.project_id) {
          modelEntities = modelEntities.whereHas('projects', function (projects) {
            projects.whereId(params.project_id);
          });
        }
      } else if (this.type === 'project') {
        var _params$user_ids;

        modelEntities = modelEntities.with('users');

        if (((_params$user_ids = params.user_ids) === null || _params$user_ids === void 0 ? void 0 : _params$user_ids.length) > 0) {
          var pus = ProjectUser.query().where(function (pu) {
            return params.user_ids.includes(pu.user_id);
          }).get();
          modelEntities = modelEntities.where(function (project) {
            return pus.filter(function (pu) {
              return pu.project_id === project.project_id;
            }).length > 0 || !!project.is_public;
          });
        }

        if (!isNil(params.billable)) {
          modelEntities = modelEntities.where(function (entity) {
            return !!entity.is_billable === !!params.billable;
          });
        }

        if (!isNil(params.public)) {
          modelEntities = modelEntities.where(function (entity) {
            return !!entity.is_public === !!params.public;
          });
        }

        if (!isNil(params.api_only)) {
          modelEntities = modelEntities.where(function (entity) {
            return !!entity.api_only === !!params.api_only;
          });
        }

        if (Object.hasOwn(params, 'integration_code') || params.integration_code && params.integration_code.replace(/ /g, '') !== '') {
          modelEntities = modelEntities.where(function (entity) {
            return entity.integration_code === params.integration_code;
          });
        }

        if (params.user_id > 0) {
          var projectUsers = ProjectUser.query().where('user_id', params.user_id).get();
          modelEntities = modelEntities.where(function (project) {
            var pu = projectUsers.find(function (pu) {
              return pu.project_id === project.project_id;
            });
            return pu && !!pu.is_member || !!project.is_public;
          });
        }
      } else if (this.type === 'client') {
        modelEntities = modelEntities.with('projects.users');
      } else if (this.type === 'category') {
        modelEntities = modelEntities.with('phases.project.users');
      } else if (this.type === 'group') {
        modelEntities = modelEntities.with('users');
      }

      if (!isNil(params.active)) {
        modelEntities = modelEntities.where(function (entity) {
          return entity.active === !!params.active;
        });
      }

      var entities = this.addOriginalValueToOptions(modelEntities.get()); // filter the entities before returning them

      return this.sortEntities(entities);
    },
    addOriginalValueToOptions: function addOriginalValueToOptions(entities) {
      var _this9 = this;

      // add original value to the list of options
      if (this.originalValue) {
        if (this.multiple) {
          if (!Array.isArray(this.originalValue)) {
            this.originalValue = [this.originalValue];
          }

          this.originalValue.forEach(function (value) {
            var option = _this9.entityModel.find(parseInt(value));

            if (option && entities.filter(function (entity) {
              return entity[_this9.entityId].toString() === value.toString();
            }).length < 1) {
              if (!(_this9.parentId && _this9.parentId > 0) || _this9.parentId && _this9.parentId > 0 && option[_this9.parentName + '_id'] === _this9.parentId) {
                entities.push(option);
              }
            }
          });
        } else {
          var option = this.entityModel.find(parseInt(this.originalValue));

          if (option && entities.filter(function (entity) {
            return entity[_this9.entityId].toString() === _this9.originalValue.toString();
          }).length < 1) {
            if (!(this.parentId && this.parentId > 0) || this.parentId && this.parentId > 0 && option[this.parentName + '_id'] === this.parentId) {
              entities.push(option);
            }
          }
        }
      }

      return entities;
    },
    getFromServer: function getFromServer() {
      var _this10 = this;

      this.loading = true;
      var params = this.getParams();

      if (this.filteredVal) {
        params.text = this.filteredVal;
      }

      return this.entityModel.api().get(this.entityURI, {
        params: params,
        save: this.persistOnStore
      }).then(function (result) {
        _this10.entityModel.commit(function (state) {
          state.lastSync = moment().unix();
        });

        if (_this10.hasFiltersChanged) {
          _this10.hasFiltersChanged = false;
        }

        _this10.loadedFromServer = true;

        if (result.response.data.data) {
          _this10.originOptions = _this10.processData(result.response.data.data);
        } else {
          _this10.originOptions = _this10.processData(result.response.data);
        }

        _this10.addOriginalValueToOptions(_this10.originOptions);

        _this10.clearLoadingState();
      }).catch(function (e) {
        _this10.entityModel.commit(function (state) {
          state.pending = false;
          state.lastSync = moment().unix();
        });

        _this10.loadedFromServer = true;
        _this10.hasFiltersChanged = false;

        _this10.clearLoadingState();
      });
    },
    filterData: function filterData(value, update) {
      var _this11 = this;

      if (this.filteredVal !== value) {
        this.filteredVal = value;
        this.loadedFromServer = false;
      }

      if (this.external && this.externalOptions.length > 0) {
        this.loadedFromServer = true;
        this.loading = false;
        this.originOptions = this.externalOptions;
      }

      if (!this.loadedFromServer) {
        if (!this.requireServer) {
          if (this.originOptions.length === 0) {
            this.originOptions = this.processData(this.getFromModel());
          }

          var processedOptions = this.filterOptions();

          if (processedOptions.validData || this.type === 'phase') {
            // we wait a tick to make sure that the selectCaue is not being updated while we are updating the options
            this.$nextTick(function () {
              _this11.autoSelectOption();
            });
            update(function () {
              _this11.options = processedOptions.data;

              if (_this11.changeLastUsed && !_this11.ignoreLastUsed) {
                _this11.changeLastUsed = false;

                _this11.updateFromLastUsed();
              }

              _this11.clearLoadingState();
            });
          } else if (this.$store.state.entities[this.entityModel.entity].lastSync != null) {
            // when require server is false but we have no data, we need to fetch from server
            this.getFromServer().then(function () {
              // order fetched data for frontend visualization
              _this11.originOptions = _this11.sortEntities(_this11.originOptions);

              _this11.autoSelectOption();
            });
          }
        } else {
          this.getFromServer().then(function () {
            // here we don't need to sort the data because it is already sorted on the server
            _this11.autoSelectOption();
          });
        }
      } else {
        update(function () {
          _this11.options = _this11.filterOptions().data;

          if (_this11.changeLastUsed && !_this11.ignoreLastUsed) {
            _this11.changeLastUsed = false;

            _this11.updateFromLastUsed();
          }

          _this11.clearLoadingState();
        });
      }
    },
    processData: function processData(entities) {
      var _this12 = this;

      forEach(entities, function (entity, index) {
        // check caption
        if (includes(_this12.captions, 'locked') && _this12.type === 'project' && !_this12.me.is_admin) {
          var membershipValid = false;

          for (var i = 0, len = entity.users.length; i < len; i++) {
            if (entity.users[i].user_id !== (_this12.filters.user_id > 0 ? _this12.filters.user_id : _this12.me.user_id)) {
              continue;
            }

            membershipValid = entity.users[i].pivot.is_member === true;
            break;
          }

          if (!membershipValid) {
            entities[index].caption = 'locked';
          }
        } else if (includes(_this12.captions, 'no-projects') && (_this12.type === 'user' && entity.projects_count === 0 || _this12.type === 'client' && entity.projects_count === 0 || _this12.type === 'group' && entity.projects_count === 0)) {
          entities[index].caption = _this12.$t('components.pickers.no_el', {
            el: _this12.$tc('general.project', 2).toLowerCase()
          });
        } else if (includes(_this12.captions, 'archived') && (_this12.type === 'project' && !entity.is_active || _this12.type === 'expense-category' && !entity.is_active || _this12.type === 'client' && !entity.is_active || _this12.type === 'phase' && !entity.is_open || _this12.type === 'user' && !entity.enabled)) {
          entities[index].caption = _this12.type === 'user' ? _this12.$tc('general.deactivated').toLowerCase() : _this12.$tc('general.archived', 1).toLowerCase();
        } else if (includes(_this12.captions, 'no-phases') && _this12.type === 'category' && entity.phases_count === 0) {
          entities[index].caption = _this12.$t('components.pickers.no_el', {
            el: _this12.$tc('general.phase', 2).toLowerCase()
          });
        } else if (includes(_this12.captions, 'no-tags') && _this12.type === 'tag-list' && entity.tags_count === 0) {
          entities[index].caption = _this12.$t('components.pickers.no_el', {
            el: _this12.$tc('general.tag', 2).toLowerCase()
          });
        } else if (includes(_this12.captions, 'no-members') && _this12.type === 'group' && entity.users_count === 0) {
          entities[index].caption = _this12.$t('components.pickers.no_el', {
            el: _this12.$tc('roles.description.member', 2).toLowerCase()
          });
        } else if (includes(_this12.captions, 'show-members') && _this12.type === 'group') {
          entities[index].caption = '';
        } else {
          entities[index].caption = '';
        } // check disable option


        if (includes(_this12.disable, 'locked') && entities[index].caption === 'locked') {
          entities[index].disable = true;
        } else if (includes(_this12.disable, 'archived') && includes(['archived', 'deactivated'], entities[index].caption)) {
          entities[index].disable = true;
        } else if (includes(_this12.disable, 'no-projects') && entities[index].caption === 'no projects') {
          entities[index].disable = true;
        } else if (includes(_this12.disable, 'no-members') && entities[index].caption === 'no members') {
          entities[index].disable = true;
        } else if (includes(_this12.disable, 'no-phases') && entities[index].caption === 'no phases') {
          entities[index].disable = true;
        } else if (includes(_this12.disable, 'no-tags') && entities[index].caption === 'no tags') {
          entities[index].disable = true;
        } else if (includes(_this12.disable, 'integration')) {
          var integrationOption = _this12.disable.filter(function (option) {
            return option.indexOf('integration:') === 0;
          }),
              integration = integrationOption.length > 0 ? integrationOption[0].split(':')[1] : null;

          if (integration && entities[index].integration_code && entities[index].integration_code === integration) {
            entities[index].disable = true;
          }
        } else if (_this12.exclude.findIndex(function (exclude) {
          return exclude[_this12.entityId] === entities[index][_this12.entityId];
        }) >= 0) {
          entities[index].disable = true; // Disable excluded options
        }
      });
      return entities;
    },
    filterOptions: function filterOptions() {
      var _this13 = this;

      var entities = this.originOptions.filter(function (entity) {
        return entity.name && entity.name.toLowerCase().includes(_this13.filteredVal.toLowerCase());
      });
      var favoriteEntities = [],
          normalEntities = entities;
      var additionalEntities = [],
          sanitizedInput = this.filteredVal.replace(/ /g, '');

      if (this.entityFavoritedParam && this.showIcon) {
        favoriteEntities = entities.filter(function (entity) {
          return entity[_this13.entityFavoritedParam];
        });
        normalEntities = entities.filter(function (entity) {
          return !entity[_this13.entityFavoritedParam];
        });
      }

      if (favoriteEntities.length > 0 && normalEntities.length > 0) {
        var _favoriteEntities$pus;

        favoriteEntities.push((_favoriteEntities$pus = {}, _defineProperty(_favoriteEntities$pus, this.entityId, 'separator-2'), _defineProperty(_favoriteEntities$pus, "separator", true), _defineProperty(_favoriteEntities$pus, "disable", true), _favoriteEntities$pus));
      }

      if (includes(this.additionalOptions, 'no-selection')) {
        var _additionalEntities$p;

        additionalEntities.push((_additionalEntities$p = {}, _defineProperty(_additionalEntities$p, this.entityId, -1), _defineProperty(_additionalEntities$p, "name", this.$t('components.pickers.no_selection')), _defineProperty(_additionalEntities$p, "additionalRow", true), _defineProperty(_additionalEntities$p, "type", 'no-selection'), _additionalEntities$p));
      }

      if (includes(this.additionalOptions, 'no-entity')) {
        var _additionalEntities$p2;

        additionalEntities.push((_additionalEntities$p2 = {}, _defineProperty(_additionalEntities$p2, this.entityId, -1), _defineProperty(_additionalEntities$p2, "name", this.$t('general.without_element', {
          el: this.$tc("general.".concat(this.type.replace(' ', '_').replace('-', '_')), 1).toLowerCase()
        })), _defineProperty(_additionalEntities$p2, "additionalRow", true), _defineProperty(_additionalEntities$p2, "type", 'no-entity'), _additionalEntities$p2));
      }

      if (includes(this.additionalOptions, 'no-change')) {
        var _additionalEntities$p3;

        additionalEntities.push((_additionalEntities$p3 = {}, _defineProperty(_additionalEntities$p3, this.entityId, null), _defineProperty(_additionalEntities$p3, "name", this.$t('general.leave_unchanged')), _defineProperty(_additionalEntities$p3, "additionalRow", true), _defineProperty(_additionalEntities$p3, "type", 'no-change'), _additionalEntities$p3));
      }

      if (includes(this.additionalOptions, 'all-option')) {
        var _additionalEntities$p4;

        additionalEntities.push((_additionalEntities$p4 = {}, _defineProperty(_additionalEntities$p4, this.entityId, -1), _defineProperty(_additionalEntities$p4, "name", this.$t('components.pickers.all_element', {
          el: this.entityName
        })), _defineProperty(_additionalEntities$p4, "additionalRow", true), _defineProperty(_additionalEntities$p4, "type", 'no-entity'), _additionalEntities$p4));
      }

      if (includes(this.additionalOptions, 'custom-option') && this.customOption) {
        additionalEntities.push(_objectSpread({
          additionalRow: true,
          type: 'custom-option'
        }, this.customOption));
      }

      if (includes(this.additionalOptions, 'new-option')) {
        if (this.canCreateEntity) {
          var _additionalEntities$p5;

          additionalEntities.push((_additionalEntities$p5 = {}, _defineProperty(_additionalEntities$p5, this.entityId, 'new-value'), _defineProperty(_additionalEntities$p5, "name", sanitizedInput !== '' && entities.length === 0 ? this.$t('components.pickers.new_row_named', {
            el: this.newRowName,
            input: sanitizedInput
          }) : this.newRowName), _defineProperty(_additionalEntities$p5, "additionalRow", true), _defineProperty(_additionalEntities$p5, "type", 'new-option'), _additionalEntities$p5));
        }
      }

      if (additionalEntities.length > 0 && entities.length > 0) {
        var _additionalEntities$p6;

        additionalEntities.push((_additionalEntities$p6 = {}, _defineProperty(_additionalEntities$p6, this.entityId, 'separator-1'), _defineProperty(_additionalEntities$p6, "separator", true), _defineProperty(_additionalEntities$p6, "disable", true), _additionalEntities$p6));
      }

      if (additionalEntities.length + favoriteEntities.length + normalEntities.length <= 0) {
        var _additionalEntities$p7;

        additionalEntities.push((_additionalEntities$p7 = {}, _defineProperty(_additionalEntities$p7, this.entityId, -1), _defineProperty(_additionalEntities$p7, "name", ''), _defineProperty(_additionalEntities$p7, "additionalRow", true), _defineProperty(_additionalEntities$p7, "type", 'empty-option'), _additionalEntities$p7));
      }

      return {
        validData: entities.length > 0,
        data: [].concat(additionalEntities, _toConsumableArray(favoriteEntities), _toConsumableArray(normalEntities))
      };
    },
    autoSelectOption: function autoSelectOption() {
      var _this14 = this;

      if (this.multiple) {
        this.selectedVal.forEach(function (val, index) {
          if (val > 0 && !_this14.originOptions.map(function (entity) {
            return entity[_this14.entityId];
          }).includes(val)) {
            _this14.selectedVal.splice(index, 1);
          }
        });
      } else {
        var value = this.selectedVal;

        if (this.selectedVal > 0 && !this.originOptions.map(function (entity) {
          return entity[_this14.entityId];
        }).includes(this.selectedVal)) {
          value = null;
        }

        var selectableOptions = this.getSelectableOptions(this.originOptions);

        if (selectableOptions.length === 1 && this.selectIfSingleOption) {
          value = selectableOptions[0][this.entityId];
        }

        if (!value || selectableOptions.filter(function (entity) {
          return entity[_this14.entityId].toString() === value.toString();
        }).length < 1) {
          if (includes(this.additionalOptions, 'no-selection')) {
            value = -1;
          }
        }

        this.selectedVal = value;
      }
    },
    openSelect: function openSelect() {
      var _this15 = this;

      this.$refs.select.showPopup();

      if (Array.isArray(this.selectedVal) && this.selectedVal.length) {
        var selectedIndex = this.options.findIndex(function (option) {
          return parseInt(option.$id) === _this15.selectedVal[0];
        });

        if (selectedIndex !== -1) {
          setTimeout(function () {
            _this15.$refs.select.scrollTo(selectedIndex);
          }, 200);
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this16 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this16.disablePicker) {
                _this16.filterData('', function (callback) {
                  return callback();
                }, function () {});
              } else {
                _this16.clearLoadingState();
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this17 = this;

    var name = this.entityName;

    if (this.type === 'tag-list') {
      name = 'tags';
    } else if (this.type === 'user') {
      name = 'users';
    } else if (this.type === 'expense-category') {
      name = 'expenses';
    }

    this.$root.$on('refresh-' + name, function () {
      if (_this17.requireServer) {
        _this17.loadedFromServer = false;
      }

      _this17.originOptions = [];

      _this17.filterData('', function (callback) {
        return callback();
      }, function () {});
    });
  },
  beforeDestroy: function beforeDestroy() {// this.$keyboard.helper.pop('esc', 'picker_' + this._uid)
  }
};